import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";
import { observer } from "mobx-react-lite";
import type React from "react";

import { theme } from "@themes/themes";

import { TradingViewBase } from "./TradingViewBase";
import { TradingViewPro } from "./TradingViewPro";

interface TradingViewProps {
  isPro?: boolean;
  isContainer?: boolean;
}

export const TradingViewChart: React.FC<TradingViewProps> = observer(({ isPro = true, isContainer = true }) => {
  const TradingViewComponent = isPro ? TradingViewPro : TradingViewBase;

  if (!isContainer) {
    return <TradingViewComponent />;
  }

  return (
    <TradingViewContainer>
      <TradingViewComponent />
    </TradingViewContainer>
  );
});

const TradingViewContainer = styled(Flex)`
  border-radius: 8px;
  border: 1px solid ${theme.color("gray-6")};
  background: ${theme.color("gray-2")};

  min-height: 0px;
  height: 100%;
  width: 100%;
`;
